import {
  Border,
  Container,
  FadeIn,
  FadeInStagger,
  GridList,
  GridListItem,
  PageIntro,
  RootLayout,
  SectionIntro,
  StatList,
  StatListItem,
} from "@/aptim/aptim";
import { ContactSection } from "~/components/ui/ContactSection";
import imageAngelaFisher from "~/img/team/angela-fisher.jpg";
import imageBenjaminRussel from "~/img/team/benjamin-russel.jpg";
import imageBlakeReid from "~/img/team/blake-reid.jpg";
import imageChelseaHagon from "~/img/team/chelsea-hagon.jpg";
import imageDriesVincent from "~/img/team/dries-vincent.jpg";
import imageEmmaDorsey from "~/img/team/emma-dorsey.jpg";
import imageJeffreyWebb from "~/img/team/jeffrey-webb.jpg";
import imageKathrynMurphy from "~/img/team/kathryn-murphy.jpg";
import imageLeonardKrasner from "~/img/team/leonard-krasner.jpg";
import imageLeslieAlexander from "~/img/team/leslie-alexander.jpg";
import imageMichaelFoster from "~/img/team/michael-foster.jpg";
import imageWhitneyFrancis from "~/img/team/whitney-francis.jpg";
import { appDetails } from "~/utils/misc";
// import { Border } from "../../components/Border";
// import { ContactSection } from "../../components/ContactSection";
// import { Container } from "../../components/Container";
// import { PageIntro } from "../../components/PageIntro";
// import { PageLinks } from "../../components/PageLinks";
// import { SectionIntro } from "../../components/SectionIntro";
// import { StatList, StatListItem } from "../../components/StatList";

function Culture() {
  return (
    <div className="mt-24 rounded-4xl bg-neutral-950 py-24 sm:mt-32 lg:mt-40 lg:py-32">
      <SectionIntro
        eyebrow="Our culture"
        title="Optimising inputs, elevating performance."
        invert
      >
        {/* <p>
          We are a group of like-minded people who share the same core values.
        </p> */}
      </SectionIntro>
      <Container className="mt-16">
        <GridList>
          <GridListItem title="Commitment to excellence" invert>
            We strive to deliver exceptional value by tailoring solutions to
            improve performance for every client. Our team continuously refines
            processes and methodologies to meet the highest standards. We
            celebrate achieving measurable results that drive meaningful impact.
          </GridListItem>
          <GridListItem title="Data-driven decision making" invert>
            We believe that effective input management is the foundation for
            operational success. Our approach leverages data analysis and
            insights to identify opportunities and optimise workflows.
            Transparency in reporting and metrics ensures accountability at
            every stage.
          </GridListItem>
          <GridListItem title="Collaboration at every level" invert>
            We partner closely with our clients, creating strategies that are
            both actionable and aligned with their goals. Internally, we foster
            a supportive environment where sharing knowledge leads to collective
            success. Collaboration drives innovation, helping us uncover new
            opportunities for improvement.
          </GridListItem>
        </GridList>
        <GridList className="mt-8">
          <GridListItem title="Empowerment through expertise" invert>
            Our team consists of seasoned consultants who empower clients with
            knowledge and tools to sustain success. Continous learning is
            embedded in our culture, ensuring we stay ahead of trends and
            challenges. We invest in professional growth for our team,
            recognising that expertise is key to client success.
          </GridListItem>
          <GridListItem title="Integrity and accountability" invert>
            We hold ourselves to the highest ethical standards, ensuring trust
            and reliability in every engagement. Accountability is at the core
            of our relationships - with clients, partners, and colleagues. Our
            actions reflect our commitment to long-term success over short-term
            gains.
          </GridListItem>
        </GridList>
      </Container>
    </div>
  );
}

const team = [
  {
    title: "Leadership",
    people: [
      {
        name: "Leslie Alexander",
        role: "Co-Founder / CEO",
        image: { src: imageLeslieAlexander },
      },
      {
        name: "Michael Foster",
        role: "Co-Founder / CTO",
        image: { src: imageMichaelFoster },
      },
      {
        name: "Dries Vincent",
        role: "Partner & Business Relations",
        image: { src: imageDriesVincent },
      },
    ],
  },
  {
    title: "Team",
    people: [
      {
        name: "Chelsea Hagon",
        role: "Senior Developer",
        image: { src: imageChelseaHagon },
      },
      {
        name: "Emma Dorsey",
        role: "Senior Designer",
        image: { src: imageEmmaDorsey },
      },
      {
        name: "Leonard Krasner",
        role: "VP, User Experience",
        image: { src: imageLeonardKrasner },
      },
      {
        name: "Blake Reid",
        role: "Junior Copywriter",
        image: { src: imageBlakeReid },
      },
      {
        name: "Kathryn Murphy",
        role: "VP, Human Resources",
        image: { src: imageKathrynMurphy },
      },
      {
        name: "Whitney Francis",
        role: "Content Specialist",
        image: { src: imageWhitneyFrancis },
      },
      {
        name: "Jeffrey Webb",
        role: "Account Coordinator",
        image: { src: imageJeffreyWebb },
      },
      {
        name: "Benjamin Russel",
        role: "Senior Developer",
        image: { src: imageBenjaminRussel },
      },
      {
        name: "Angela Fisher",
        role: "Front-end Developer",
        image: { src: imageAngelaFisher },
      },
    ],
  },
];

function Team() {
  return (
    <Container className="mt-24 sm:mt-32 lg:mt-40">
      <div className="space-y-24">
        {team.map((group) => (
          <FadeInStagger key={group.title}>
            <Border as={FadeIn} />
            <div className="grid grid-cols-1 gap-6 pt-12 sm:pt-16 lg:grid-cols-4 xl:gap-8">
              <FadeIn>
                <h2 className="font-display text-2xl font-semibold text-neutral-950">
                  {group.title}
                </h2>
              </FadeIn>
              <div className="lg:col-span-3">
                <ul
                  role="list"
                  className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:gap-8"
                >
                  {group.people.map((person) => (
                    <li key={person.name}>
                      <FadeIn>
                        <div className="group relative overflow-hidden rounded-3xl bg-neutral-100">
                          <img
                            alt=""
                            src={person.image.src}
                            className="h-96 w-full object-cover grayscale transition duration-500 motion-safe:group-hover:scale-105"
                          />
                          <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-black to-black/0 to-40% p-6">
                            <p className="font-display text-base/6 font-semibold tracking-wide text-white">
                              {person.name}
                            </p>
                            <p className="mt-2 text-sm text-white">
                              {person.role}
                            </p>
                          </div>
                        </div>
                      </FadeIn>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </FadeInStagger>
        ))}
      </div>
    </Container>
  );
}

// export const metadata: Metadata = {
//   title: "About Us",
//   description:
//     "We believe that our strength lies in our collaborative approach, which puts our clients at the center of everything we do.",
// };

export default function DataDock() {
  // let blogArticles = (await loadArticles()).slice(0, 2);

  return (
    <RootLayout>
      <div className="mt-24 sm:mt-32 lg:mt-40">
        <PageIntro eyebrow="DataDock" title={appDetails.companyTagline}>
          <p>{appDetails.companyBlurb}</p>
          {/* <div className="mt-10 max-w-2xl space-y-6 text-base">
          <p>
            Studio was started by three friends who noticed that developer
            studios were charging clients double what an in-house team would
            cost. Since the beginning, we have been committed to doing things
            differently by charging triple instead.
          </p>
          <p>
            At Studio, we’re more than just colleagues — we’re a family. This
            means we pay very little and expect people to work late. We want our
            employees to bring their whole selves to work. In return, we just
            ask that they keep themselves there until at least 6:30pm.
          </p>
        </div> */}
        </PageIntro>
        <Container className="mt-16">
          <StatList>
            <StatListItem value="35" label="Underpaid employees" />
            <StatListItem value="52" label="Placated clients" />
            <StatListItem value="$25M" label="Invoices billed" />
          </StatList>
        </Container>

        <Culture />

        <Team />

        {/* <PageLinks
        className="mt-24 sm:mt-32 lg:mt-40"
        title="From the blog"
        intro="Our team of experienced designers and developers has just one thing on their mind; working on your ideas to draw a smile on the face of your users worldwide. From conducting Brand Sprints to UX Design."
        pages={blogArticles}
      /> */}

        <ContactSection />
      </div>
    </RootLayout>
  );
}
